const volunteerDetails = [
    {   name: "OrcaSound",
        time: "2021-2022",
        tech: "Python.RaspberryPi.Docker",
        story: "OrcaSound installs RaspberryPi in the ocean to track Orca whales’ sounds and movement. The data is sent to marine biologists and the US Ocean Observatories Initiative to preserve Orca and other marine species."},
    {   name: "HumanityForward",
        time: "2021",
        tech: "ReactJS",
        story: "HumanityForward works with a burgeoning, bipartisan coalition of lawmakersto advance direct cash transfers to the American people."},
    {   name: "DemocracyLab",
        time: "2019",
        tech: "ReactJS",
        story: "DemocracyLab connects programming volunteers with tech-for-good projects to facilitate the realization of MVP's for these startups."},
    {   name: "AccessibilityApp",
        time: "2021",
        tech: "ASP.NET",
        story: "AccessibilityApp promotes accessibility of technology by allowing users to rate public websites."},
];

export default volunteerDetails;